import React from "react";

const FilterNode = ({ node, nodePath, expandedNodes, onToggle, onFiltered, isActive, filters }) => {
  const isExpanded = expandedNodes.has(nodePath);
  const hasChildren = node.children && node.children.length > 0;
  const baseClass = 'filter-node';
  const expandedClass = isExpanded ? 'expanded' : 'collapsed';
  const itemClass = `${baseClass} ${expandedClass}`;

  // Helper to build a filter href for opening in a new tab
  const getFilterHref = () => {
    if (!node.fieldname) return '#';
    const newFilters = { ...filters, [node.fieldname]: node.text, start: 1 };
    // Remove empty/null/undefined values
    const cleaned = Object.fromEntries(Object.entries(newFilters).filter(([_, v]) => v != null && v !== ""));
    const params = new URLSearchParams(cleaned).toString();
    return `?${params}`;
  };

  // Handler for link click (filter action)
  const handleLinkClick = (e) => {
    // Only filter in this tab if not a new tab/middle click
    if (
      e.ctrlKey ||
      e.metaKey ||
      e.shiftKey ||
      e.button === 1
    ) {
      return;
    }
    e.preventDefault();
    if (onFiltered) onFiltered(node, nodePath, !node.activated, node.fieldname);
  };



  // If the current node is active, only render its children (if any)
  if (isActive) {
    return hasChildren ? (
      <div className={itemClass} style={{ marginLeft: 16 }}>
        {node.children.map((child, idx) => (
          <FilterNode
            key={idx}
            node={child}
            nodePath={`${nodePath}-${idx}`}
            expandedNodes={expandedNodes}
            onToggle={onToggle}
            onFiltered={onFiltered}
            isActive={child.currentIsFilterable && child.activated}
            filters={filters}
          />
        ))}
      </div>
    ) : null;
  }

  // If node is filterable and has children, only show the link (no expand/collapse)
  if (node.currentIsFilterable && hasChildren) {
    return (
      <div className={itemClass} style={{ marginLeft: 16, display: 'flex', alignItems: 'center' }}>
        <a
          href={getFilterHref()}
          onClick={handleLinkClick}
          style={{
            fontWeight: isActive ? 'bold' : 'normal',
            color: isActive ? '#1976d2' : undefined,
            textDecoration: 'underline',
            cursor: 'pointer',
            marginRight: 4
          }}
        >
          {node.text}
        </a>
      </div>
    );
  }

  // If node is filterable and has no children
  if (node.currentIsFilterable && !hasChildren) {
    return (
      <div className={itemClass} style={{ marginLeft: 16, display: 'flex', alignItems: 'center' }}>
        <a
          href={getFilterHref()}
          onClick={handleLinkClick}
          style={{
            fontWeight: isActive ? 'bold' : 'normal',
            color: isActive ? '#1976d2' : undefined,
            textDecoration: 'underline',
            cursor: 'pointer',
            marginRight: 4
          }}
        >
          {node.text}
        </a>
      </div>
    );
  }

  return (
    <div className={itemClass} style={{ marginLeft: 16 }}>
      {hasChildren && !node.currentIsFilterable && (
        <span
          style={{ cursor: "pointer", marginRight: 4 }}
          onClick={() => onToggle(nodePath)}
          aria-label={isExpanded ? "Collapse" : "Expand"}
        >
          {isExpanded ? "▼" : "▶"}
        </span>
      )}
      {node.currentIsFilterable ? (
        <a
          href={getFilterHref()}
          onClick={handleLinkClick}
          style={{
            fontWeight: isActive ? 'bold' : 'normal',
            color: isActive ? '#1976d2' : undefined,
            textDecoration: 'underline',
            cursor: 'pointer',
            marginRight: 4
          }}
        >
          {node.text}
        </a>
      ) : (
        <span style={{cursor: 'pointer'}}  onClick={() => onToggle(nodePath)}>{node.text}</span>
      )}
      {/* Render children if expanded */}
      {hasChildren && isExpanded && !node.currentIsFilterable && (
        <div style={{ marginLeft: 16 }}>
          {node.children.map((child, idx) => (
            <FilterNode
              key={idx}
              node={child}
              nodePath={`${nodePath}-${idx}`}
              expandedNodes={expandedNodes}
              onToggle={onToggle}
              onFiltered={onFiltered}
              isActive={child.currentIsFilterable && child.activated}
              filters={filters}
            />
          ))}
        </div>  
      )}
    </div>
  );
};

export default FilterNode;